export default {
  name: 'MakeupDayForm',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        link: null
      },
      errors: {},
      loading: false
    };
  },
  mounted() {
    // Create a Bootstrap modal.
    this.modal = jQuery(this.$refs.modal).modal({
      backdrop: 'static',
      keyboard: false,
      focus: true,
      show: false
    });
    this.modal.on('shown.bs.modal', this.shown.bind(this));
    this.modal.on('hidden.bs.modal', this.reset.bind(this));
  },
  watch: {
    show(value) {
      if (value) {
        this.modal.modal('show');
      } else {
        this.modal.modal('hide');
      }
    }
  },
  methods: {
    shown() {},
    reset() {
      this.form = {
        link: null
      };
      this.errors = {};
      this.loading = false;
    },
    onSubmit() {
      if (this.loading) {
        return;
      }
      this.error = {};
      this.loading = true;
      this.$store.dispatch('profile/updateLink', {
        projectID: this.project.id,
        form: this.form
      }).then(responseData => {
        this.$emit('input', false);
        this.$nextTick(() => {
          this.$emit('success', responseData);
        });
      }).catch(error => {
        const responseData = error.responseJSON;
        if (responseData && responseData.errors) {
          this.errors = responseData.errors;
        }
        this.$emit('failure', responseData);
      }).finally(() => {
        this.loading = false;
      });
    },
    onCancel() {
      this.$emit('input', false);
    }
  },
  computed: {
    show() {
      return this.value;
    }
  }
};